import { CSShiftOptionType } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/types';
import { csDayConflictHighlightGetter } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/utils';
import { resourceConflictHighlightGetter } from '@lp/features/Scheduler/utils';
import { CSShiftType } from '@/api/apis/resources/schedule';
import { getNameValuesFromEnumNames } from '@/utils/helpers';
import { NameByValue } from '@/types';

export const singleCSShiftTypes: CSShiftType[] = [];

export const hubRelatedCSShiftTypes = [CSShiftType.OnCall, CSShiftType.AtHub, CSShiftType.TravelDay];

export const organSelectCSShiftOptionTypes = [
  CSShiftOptionType.OnCall,
  CSShiftOptionType.ExtraCall,
  CSShiftOptionType.PhoneSupport,
];

export const csShiftTypeNames: Record<CSShiftType, string> = {
  [CSShiftType.AtHub]: 'At Hub',
  // [CSShiftType.OfficeDay]: 'Office Day',
  [CSShiftType.OfficeDay]: 'Admin Day',
  [CSShiftType.NoCall]: 'No Call',
  [CSShiftType.OnCall]: 'On Call',
  [CSShiftType.Sick]: 'Sick Leave',
  [CSShiftType.PhoneSupport]: 'Clinical Lead',
  [CSShiftType.Unavailable]: 'Unavailable',
  [CSShiftType.Vacation]: 'Vacation',
  [CSShiftType.WeekendOff]: 'Weekend Off',
  [CSShiftType.TravelDay]: 'Travel Day',
};

export const csShiftOptionTypeNames: Record<CSShiftOptionType, string> = {
  [CSShiftOptionType.OnCall]: csShiftTypeNames[CSShiftType.OnCall],
  [CSShiftOptionType.ExtraCall]: 'Extra Call',
  [CSShiftOptionType.OfficeDay]: csShiftTypeNames[CSShiftType.OfficeDay],
  [CSShiftOptionType.AtHub]: csShiftTypeNames[CSShiftType.AtHub],
  [CSShiftOptionType.PhoneSupport]: csShiftTypeNames[CSShiftType.PhoneSupport],
  [CSShiftOptionType.NoCall]: csShiftTypeNames[CSShiftType.NoCall],
  [CSShiftOptionType.BlockedNoCall]: 'No Call (Blocked)',
  [CSShiftOptionType.WeekendOff]: csShiftTypeNames[CSShiftType.WeekendOff],
  [CSShiftOptionType.TravelDay]: csShiftTypeNames[CSShiftType.TravelDay],
  [CSShiftOptionType.FloatingHoliday]: 'Floating Holiday',
  [CSShiftOptionType.Sick]: csShiftTypeNames[CSShiftType.Sick],
  [CSShiftOptionType.Vacation]: csShiftTypeNames[CSShiftType.Vacation],
  [CSShiftOptionType.Unavailable]: csShiftTypeNames[CSShiftType.Unavailable],
};

export const csShiftOptionDropdownItems = [
  CSShiftOptionType.OnCall,
  CSShiftOptionType.ExtraCall,
  CSShiftOptionType.OfficeDay,
  CSShiftOptionType.AtHub,
  CSShiftOptionType.PhoneSupport,
  CSShiftOptionType.NoCall,
  CSShiftOptionType.BlockedNoCall,
  CSShiftOptionType.WeekendOff,
  CSShiftOptionType.TravelDay,
  CSShiftOptionType.FloatingHoliday,
  CSShiftOptionType.Sick,
  CSShiftOptionType.Unavailable,
];

export const csRegionTotalsShiftTypeNames: Record<CSShiftOptionType, string> = {
  ...csShiftOptionTypeNames,
  [CSShiftOptionType.Unavailable]: 'N/A',
  [CSShiftOptionType.WeekendOff]: 'Weekend',
  [CSShiftOptionType.TravelDay]: 'Travel',
  [CSShiftOptionType.FloatingHoliday]: 'Holiday',
  [CSShiftOptionType.PhoneSupport]: 'С. Lead',
  [CSShiftOptionType.BlockedNoCall]: 'B. No Call',
};

export const csRegionTotalsShiftTypes = [
  CSShiftOptionType.OnCall,
  CSShiftOptionType.ExtraCall,
  CSShiftOptionType.AtHub,
  CSShiftOptionType.TravelDay,
  CSShiftOptionType.OfficeDay,
  CSShiftOptionType.PhoneSupport,
  CSShiftOptionType.NoCall,
  CSShiftOptionType.BlockedNoCall,
  CSShiftOptionType.WeekendOff,
  CSShiftOptionType.Vacation,
  CSShiftOptionType.FloatingHoliday,
  CSShiftOptionType.Sick,
  CSShiftOptionType.Unavailable,
];

export const CS_SHIFT_TYPE_SELECT_LIST = getNameValuesFromEnumNames(csShiftTypeNames);
export const CS_SHIFT_OPTION_TYPE_SELECT_LIST = getNameValuesFromEnumNames(csShiftOptionTypeNames);
export const CS_SHIFT_OPTION_DROPDOWN_LIST: NameByValue<CSShiftOptionType>[] = csShiftOptionDropdownItems.map((so) => {
  return {
    value: so,
    name: csShiftOptionTypeNames[so],
  };
});

export const csConflictsDrawerData = [
  { label: 'BY USER', accessorKey: 'resourcesMessagesList', transformerFn: resourceConflictHighlightGetter } as const,
  { label: 'BY HUB', accessorKey: 'hubsMessagesList', transformerFn: csDayConflictHighlightGetter } as const,
  { label: 'BY REGION', accessorKey: 'regionsMessagesList' } as const,
  { label: 'LEAD', accessorKey: 'supportMessagesList', ignoreDay: true } as const,
];

// Clinical Lead (Phone Support) is not planned in deduction-rules mode periods.
export const csDeductionRulesConflictsDrawerData = csConflictsDrawerData.filter(
  (tab) => tab.accessorKey !== 'supportMessagesList',
);
